export default __webpack_public_path__ + "static/media/tien.676cde61.jpg";